import React, { useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import SignInForm from './signForm';
import { IFormValues } from './signForm/types';
import { SignInAdminProps } from './types';

/**
 * Acesso de suporte: o operador logado abre a sessão da conta informada na rota.
 *
 * A senha pedida é a dele, não uma senha compartilhada de suporte — o VAULT
 * confere a credencial do operador, exige a permissão de acesso e registra quem
 * entrou em qual conta. Por isso a tela agora exige sessão: sem ela não há ator
 * a autenticar.
 */
const SignIn: React.FC<SignInAdminProps> = (props: SignInAdminProps) => {
  const { isLoading, match, isAuthenticated } = props;
  const { email } = match.params;
  const history = useHistory();
  const [granted, setGranted] = useState(false);

  const onSignFormSubmit = async (values: IFormValues) => {
    const { password } = values;
    const accessed = await props.impersonateUser({ targetEmail: email, password });

    if (accessed) {
      setGranted(true);
    }
  };

  // Depois de trocar a sessão, "/" resolve a rota pelo userType do usuário
  // acessado — ir direto para /admin/painel-de-vendas deixava a tela em branco
  // ao acessar conta de outro tipo.
  if (granted) {
    history.push('/');
    return null;
  }

  if (!isAuthenticated) {
    return (
      <Redirect to="/login" />
    );
  }

  return (
    <SignInForm
      loading={isLoading}
      onSignInFormSubmit={onSignFormSubmit}
    />
  );
}

export default SignIn;
